import React from "react";
import RegisterInner from "../components/RegisterInner";

const RegisterPage = () => {
  return (
    <>
      {/* RegisterInner */}
      <RegisterInner />
    </>
  );
};

export default RegisterPage;
